module.exports = __webpack_public_path__ + "img/spotcancerearly-leaflet.679090b7.png";